import { Component, inject } from '@angular/core';
import { QualificationsUtilityService } from '@wilson/qualifications';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'wilson-status-icon-renderer',
  template: `
    <span>
      <img
        src="../../../assets/img/svg-icons/qualification_status_{{
          cellValue
        }}.svg"
      />
    </span>
  `,
  styles: [],
  standalone: false,
})
export class StatusIconRendererComponent implements AgRendererComponent {
  private qualificationsUtilService = inject(QualificationsUtilityService);

  public cellValue: string;

  agInit(params: ICellRendererParams): void {
    this.cellValue = this.qualificationsUtilService.getQualificationStatus(
      params.data,
    );
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = this.qualificationsUtilService.getQualificationStatus(
      params.data,
    );
    return true;
  }

  getBadgeStatus(params: ICellRendererParams) {
    return params.data.canAccessWilson;
  }
}
